import { Howl } from "howler";
import { writable, get } from "svelte/store";
import { appStarted, assetsProgress } from "../store/AppState";

export const soundTracks = writable<Howl[]>([]);
export const isPlaying = writable<boolean>(false);
export const soundFinished = writable<boolean>(false);
export const muteSounds = writable<boolean>(false);
export const soundsLoaded = writable<boolean>(false);

export const initializeSounds = (audioFiles: string[]) => {
  let loadedCounter = 0;
  soundTracks.set(
    audioFiles.map((file, index) => {
      const sound = new Howl({ src: file });
      sound.on("end", () => {
        isPlaying.set(false);
        soundFinished.set(true);
        if (index === 6 || index === 5) {
          //get(soundTracks)[24].fade(0, 0.15, 2000);
        }
      });
      sound.on("pause", () => {
        isPlaying.set(false);
        if (index === 6 || index === 5) {
          //get(soundTracks)[24].fade(0, 0.15, 2000);
        }
      });
      sound.on("stop", () => {
        isPlaying.set(false);
        if (index === 6 || index === 5) {
          //get(soundTracks)[24].fade(0, 0.15, 2000);
        }
      });
      sound.on("play", () => {
        isPlaying.set(true);
        if (index === 6 || index === 5) {
          get(soundTracks)[24].fade(0.15, 0, 2000);
        }
      });
      sound.on("load", () => {
        loadedCounter++;
        assetsProgress.set(get(assetsProgress) + 1);
        if (loadedCounter >= 52) {
          soundsLoaded.set(true);
        }
        if (index === 24 && get(appStarted) === true) {
          sound.volume(0.15);
          sound.play();
          sound.loop(true);
        }
      });
      return sound;
    })
  );
};

export const destroySounds = () => {
  get(soundTracks).forEach((sound) => {
    sound.stop();
    isPlaying.set(false);
    sound.unload();
  });
  soundTracks.set([]);
};

export const playMusic = () => {
  const music = get(soundTracks)[24];
  if (music) {
    music.volume(0.15);
    music.play();
    music.loop(true);
  }
};

export const playSound = (soundIndex: number) => {
  stopDialogue();
  get(soundTracks).forEach((sound, index) => {
    if (sound.playing()) {
      if (soundIndex === index) {
        sound.stop();
      } else {
        if (index !== 24) {
          sound.volume(0.3);
        } else {
        }
        // sound.stop();
      }
    }
  });
  get(soundTracks)[soundIndex].volume(1);
  get(soundTracks)[soundIndex].play();
  if (soundIndex === 5 || soundIndex === 6) {
    get(soundTracks)[24].fade(0.15, 0, 2000);
    get(soundTracks)[soundIndex].once("end", () => {
      get(soundTracks)[24].fade(0, 0.15, 2000);
      get(soundTracks)[soundIndex].off("stop");
    });
    get(soundTracks)[soundIndex].once("stop", () => {
      get(soundTracks)[24].fade(0, 0.15, 2000);
      get(soundTracks)[soundIndex].off("end");
    });
  }
  soundFinished.set(false);
};

export const playDialogue = (index: number, counter: number) => {
  const sounds = get(soundTracks);
  const sound = sounds[25 + index + counter];
  if (sound.playing() || sound.seek() !== 0) {
    sound.stop();
  }
  sound.volume(0.7);
  sound.play();
};

export const stopDialogue = () => {
  const sounds = get(soundTracks);
  const soundSubsets = sounds.slice(25);
  soundSubsets.forEach((sound) => {
    sound.volume(0.2);
  });
};

let closedGiftSoundPlaying = false;
export const playClosedGiftSound = (index: number) => {
  const sounds = get(soundTracks);
  const sound = sounds[sounds.length - 1 - index];
  if (closedGiftSoundPlaying) {
    return;
  }
  sound.volume(0.7);
  sound.play();
  closedGiftSoundPlaying = true;
  sound.on("end", () => (closedGiftSoundPlaying = false));
};

export const toggleSound = (soundIndex: number) => {
  const sound = get(soundTracks)[soundIndex];
  if (sound.playing()) {
    sound.pause();
  } else {
    sound.play();
  }
};

export const stopSound = (soundIndex: number) => {
  const sound = get(soundTracks)[soundIndex];
  if (sound && sound.playing()) {
    sound.stop();
  }
};

export const toggleMute = () => {
  Howler.mute(!get(muteSounds));
  muteSounds.set(!get(muteSounds));
};

export const suppressSounds = (shouldSuppress: boolean) => {
  if (!shouldSuppress && get(muteSounds) === true) {
    return;
  } else {
    Howler.mute(shouldSuppress);
  }
};
